import { jsxs as t, jsx as o } from "react/jsx-runtime";
import m from "clsx";
import { ModalCloseButton as a } from "./ModalCloseButton.js";
import e from "../Modal.module.css.js";
const p = ({ children: r, className: s }) => /* @__PURE__ */ t("header", { className: m(e.header, s), children: [
  /* @__PURE__ */ o("h2", { className: e.title, children: r }),
  /* @__PURE__ */ o(a, {})
] });
export {
  p as ModalHeader
};
//# sourceMappingURL=ModalHeader.js.map
